// extracted by mini-css-extract-plugin
module.exports = {"list":"moreHolidayBook_list_AoXz5"};